import RfqAccordion from './RfqAccordion';
import RfqCard from './RfqCard';
import RfqProjectInfo from './RfqCardProjectInfo';
import { ProjectStatusLabel } from './RfqCardStatus';

const Card = Object.assign(RfqCard, {
  Accordion: RfqAccordion,
  ProjectInfo: RfqProjectInfo,
  Status: ProjectStatusLabel
});

export default Card;
